import { Button, Form, Modal } from 'antd'
import { PriceHistory } from 'components/Sales/Client/Contract/Form/PriceHistory'
import RatesForm from '../../../../../components/Sales/Client/Contract/Form/RatesForm'
import useFetchSelect from '../../../../../elements/Hooks/useFetchSelect'
import useModalShow from '../../../../../elements/Hooks/useModalShow'
import { strVal } from '../../../../../modules/Utils'
import moment from 'moment'
import React from 'react'

import CustomTable from '../../../../../elements/Table/CustomTable'
import { checkForm } from '../../../../../modules/Utils'

function Rates(props) {
  let uuid = moment().unix()

  const { type, contract, updateContract, form } = props

  const [data, setData] = React.useState([])
  const [history, setHistory] = React.useState([])

  const owner = strVal(contract, 'company._id')
  const url = `products/?${owner ? `owner=${owner}&` : ''}state=Active&select=_id,type,name`
  const { SelectData: ProductsSelect, selected: product } = useFetchSelect({ url })
  const [uom, setUom] = React.useState({})

  React.useEffect(() => {
    if (contract.rates) {
      let data_ = contract.rates.map((item) => ({ ...item }))
      data_.forEach((i) => {
        if (!i.key) i.key = (uuid++).toString()
      })
      setData(data_)
    }
  }, [contract])

  const remove = () => {
    let newData = [...data]
    newData = newData.filter((i) => object.key !== i.key)
    setData(newData)
    updateContract('rates', newData)
    onCancel()
  }

  const update = async () => {
    const formData = await checkForm(formRef)
    const newData = data.map((i) =>
      object.key === i.key ? { ...i, ...formData, product, productLine: uom, history } : i
    )

    setData(newData)
    updateContract('rates', newData)
    onCancel()
  }

  const save = async () => {
    const formData = await checkForm(formRef)
    const newData = [
      ...data,
      {
        //no: data.length + 1,
        no: ('000' + (data.length + 1)).slice(-3),
        ...formData,
        product,
        history,
        productLine: uom,
      },
    ]

    setData(newData)
    updateContract('rates', newData)
    onCancel()
  }

  let columns = [
    {
      Header: 'Item',
      accessor: 'no',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Product', accessor: 'product.name' },
    { Header: 'Description', accessor: 'description' },
    { Header: 'Ref Product ID', accessor: 'ref' },
    { Header: 'UoM', accessor: 'productLine.name' },
    { Header: 'Unit Price', accessor: 'rate' },
    { Header: 'Tax Type', accessor: 'tax.type' },
    { Header: 'Tax Rate', accessor: 'tax.rate' },
  ]

  columns = type === 'view' ? columns.filter((c) => c.accessor !== 'operation') : columns

  const {
    visible,
    onShow: _onShow,
    onCancel: _onCancel,
    isNew,
    payload: { object },
  } = useModalShow()

  function onShow(original, type) {
    setHistory(original.history || [])
    _onShow(original, type)
  }

  function onCancel() {
    setHistory([])
    setUom({})
    _onCancel()
  }

  const formRef = React.createRef()

  return (
    <>
      <Modal
        title={isNew ? 'Add New Rate' : 'Update Rate'}
        visible={visible}
        width={'70%'}
        destroyOnClose
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => (isNew ? save() : update())}>
            {isNew ? 'Save' : 'Update'}
          </Button>,
          !isNew && (
            <Button htmlType="button" type="danger" onClick={remove}>
              Remove
            </Button>
          ),
        ]}>
        <RatesForm
          ref={formRef}
          data={isNew ? {} : object}
          {...{
            ProductsSelect,
            product,
            uom,
            isNew,
            setUom,
            history,
            setHistory,
          }}
        />

        <PriceHistory {...{ history, setHistory, object }} />
      </Modal>

      <CustomTable
        CreateButton={() => (
          <Button
            style={{
              float: 'left',
              marginRight: 10,
            }}
            size={'small'}
            onClick={onShow}
            type={'primary'}
            icon={'plus'}>
            Add a Rate
          </Button>
        )}
        hide={{
          refresh: true,
          create: type === 'view',
        }}
        data={data}
        loading={false}
        pagination={false}
        columns={columns}
        size="small"
        defaultSorted={[
          {
            id: 'no',
            desc: false,
          },
        ]}
        style={{ marginTop: 10 }}
      />
    </>
  )
}

export default Form.create()(Rates)
